import { TRIGGER_REPAYMENT_STATUS_API_CALL, TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS } from 'redux/actionTypes';

export function triggerRepaymentStatusApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_REPAYMENT_STATUS_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerRepaymentStatusApiCallSuccess(data) {
	return {
		type: TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS,
		data,
	};
}
